module.exports = __webpack_public_path__ + "media/images/edion/zh/header-92af74186d97322117f73054ae682175.png";